// SideBar.js

import React, { Component } from 'react';

export default class SideBar extends Component {
    static defaultProps = {
        onPress: () => { },
        control: false
    }
    constructor(props) {
        super(props);
        this.state = {
            login: this.props.login
        }
    }
    onPress(name) {
        if (this.props.login) {
            this.props.onPress(name);
        } else {
            alert('로그인이 필요합니다.');
        }
    }
    render() {
        return (
            this.props.control == true ?
                <aside className="main-sidebar">
                    <section className="sidebar">
                        <div className="user-panel">
                            <div className="pull-left image">
                                <img src="img/avatar.png" className="img-circle" alt="User Image" />
                            </div>
                            <div className="pull-left info">
                                <p>Admin</p>
                                <a href="#"><i className="fa fa-circle text-success"></i>{this.props.login ? 'Online' : 'Offline'}</a>
                            </div>
                        </div>
                        <form action="#" method="get" className="sidebar-form">
                            <div className="input-group">
                                <input type="text" name="q" className="form-control" placeholder="Search..." />
                                <span className="input-group-btn">
                                    <button type="submit" name="search" id="search-btn" className="btn btn-flat"><i className="fa fa-search"></i>
                                    </button>
                                </span>
                            </div>
                        </form>
                        <ul className="sidebar-menu" data-widget="tree">
                        <li>
                                <a href="#" onClick={(e) => this.onPress('banner')}>
                                    <i className="fa fa-th"></i> <span>배너 관리</span>
                                </a>
                            </li>

                            <li>
                                <a href="#" onClick={(e) => this.onPress('product')}>
                                    <i className="fa fa-cart-plus"></i> <span>상품 관리</span>
                                </a>
                            </li>
                            <li>
                                <a href="#" onClick={(e) => this.onPress('users')}>
                                    <i className="fa fa-th"></i> <span>회원 관리</span>
                                </a>
                            </li>
                            <li>
                                <a href="#" onClick={(e) => this.onPress('devices')}>
                                    <i className="fa fa-th"></i> <span>이용자 관리</span>
                                </a>
                            </li>
                            <li>
                                <a href="#" onClick={(e) => this.onPress('payments')}>
                                    <i className="fa fa-th"></i> <span>결제 목록</span>
                                </a>
                            </li>                            
                            <li>
                                <a href="#" onClick={(e) => this.onPress('purchase')}>
                                    <i className="fa fa-th"></i> <span>구매 목록</span>
                                </a>
                            </li>
                            <li>
                                <a href="#" onClick={(e) => this.onPress('notice')}>
                                    <i className="fa fa-th"></i> <span>공지 사항</span>
                                    <span className="pull-right-container">
                                        <small className="label pull-right bg-green">new</small>
                                    </span>
                                </a>
                            </li>
                            <li>
                                <a href="#" onClick={(e) => this.onPress('faq')}>
                                    <i className="fa fa-th"></i> <span>자주 묻는 질문</span>
                                    <span className="pull-right-container">
                                        <small className="label pull-right bg-green">new</small>
                                    </span>
                                </a>
                            </li>
                            <li>
                                <a href="#" onClick={(e) => this.onPress('inquiry')}>
                                    <i className="fa fa-th"></i> <span>1:1 문의</span>
                                    <span className="pull-right-container">
                                        <small className="label pull-right bg-green">new</small>
                                    </span>
                                </a>
                            </li>
                            <li>
                                <a href="#" onClick={(e) => this.onPress('mediareply')}>
                                    <i className="fa fa-th"></i> <span>댓글 리스트</span>
                                    <span className="pull-right-container">
                                        <small className="label pull-right bg-green">new</small>
                                    </span>
                                </a>
                            </li>                            
                            <li>
                                <a href="#" onClick={(e) => this.onPress('push')}>
                                    <i className="fa fa-th"></i> <span>PUSH 알림 전송</span>
                                    <span className="pull-right-container">
                                        <small className="label pull-right bg-green">new</small>
                                    </span>
                                </a>
                            </li>
                            <li className="treeview">
                                <a href="#">
                                    <i className="fa fa-files-o"></i>
                                    <span>약관/개인정보/고지/정책</span>
                                    <span className="pull-right-container">
                                        <span className="label label-primary pull-right">5</span>
                                    </span>
                                </a>
                                <ul className="treeview-menu">
                                    <li><a href='#' onClick={(e) => this.props.onPress('terms')}><i className="fa fa-circle-o"></i>이용약관</a></li>
                                    <li><a href='#' onClick={(e) => this.props.onPress('payterms')}><i className="fa fa-circle-o"></i>유료서비스 이용약관</a></li>
                                    <li><a href='#' onClick={(e) => this.props.onPress('privacy')}><i className="fa fa-circle-o"></i>개인정보처리방침</a></li>
                                    <li><a href='#' onClick={(e) => this.props.onPress('youth')}><i className="fa fa-circle-o"></i>청소년보호정책</a></li>
                                    <li><a href='#' onClick={(e) => this.props.onPress('legal')}><i className="fa fa-circle-o"></i>법적고지</a></li>
                                    <li><a href='#' onClick={(e) => this.props.onPress('cookie')}><i className="fa fa-circle-o"></i>쿠키정책</a></li>
                                </ul>
                            </li>
                            <li className="treeview">
                                <a href="#">
                                    <i className="fa fa-files-o"></i>
                                    <span>구매인증내역/등록</span>
                                    <span className="pull-right-container">
                                        <span className="label label-primary pull-right">2</span>
                                    </span>
                                </a>
                                <ul className="treeview-menu">
                                    <li><a href='#' onClick={(e) => this.props.onPress('purchaseRegList')}><i className="fa fa-th"></i>구매인증내역</a></li>
                                    <li><a href='#' onClick={(e) => this.props.onPress('purchaseReg')}><i className="fa fa-th"></i>구매인증등록</a></li>
                                </ul>
                            </li>
                            <li>
                                <a href="#" onClick={(e) => this.props.onPress('logout')}>
                                    <i className="fa fa-sign-out"></i> <span>Logout</span>
                                </a>
                            </li>
                        </ul>
                    </section>
                </aside>
                :
                <aside className="main-sidebar">
                    <section className="sidebar">
                        <div className="user-panel">
                            <div className="pull-left image">
                                <img src="img/avatar.png" className="img-circle" alt="User Image" />
                            </div>
                            <div className="pull-left info">
                                <p>User</p>
                                <a href="#"><i className="fa fa-circle text-success"></i>{this.props.login ? 'Online' : 'Offline'}</a>
                            </div>
                        </div>
                        <ul className="sidebar-menu" data-widget="tree">
                            <li>
                                <a href="#" onClick={(e) => this.props.onPress('logout')}>
                                    <i className="fa fa-sign-out"></i> <span>Logout</span>
                                </a>
                            </li>
                        </ul>
                    </section>
                </aside>
        )
    }
}



// WEBPACK FOOTER //
// src/components/SideBar.js